import { useMutation } from '@tanstack/react-query';

import { downloadBlob } from '../fetch';

type Payload = {
  ids: number[];
};

export const useDownloadInvoiceFcXlsx = () => {
  return useMutation({
    mutationFn: (body: Payload) => {
      return downloadBlob('/invoices/download/fc-xlsx', {
        method: 'POST',
        body,
      });
    },
  });
};
